import React from "react";
import { css } from "styled-components";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography from "@insite/mobius/Typography";
import parse from "html-react-parser";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";

const enum fields {
    categoryLink = 'categoryLink',
    categoryIcon = 'categoryIcon',
    categoryIconSize = 'categoryIcon',
    title = 'title',
    subTitle = 'subTitle',
    altText = "altText",

}

interface Props extends WidgetProps {
    fields: {
        [fields.categoryLink]: string;
        [fields.categoryIcon]: string; 
        [fields.title]: string; 
        [fields.subTitle]: string; 
        [fields.altText]: string;
        [fields.categoryIconSize]: string;
    }
}

const CustomBox: React.FC<Props> = ({fields, id}) => {
    const {categoryLink, categoryIcon, title, subTitle, altText} = fields;

    const wrapperStyles = {
        css: css`
            text-align: center;
            min-height: 100%;
            padding-top: 2rem;
            &:hover{
                background: '#016EAF';
            }
        `
    }

    const hoverWrapperStyles = {
        css: css `
            background-color: '#016EAF';
        `
    }
    
    const imageWrapperStyles = {
        css: css` 
            min-height:100px
          
        `
    }

    const image = <LazyImage src={categoryIcon} altText={altText}  />;

    return (
        <StyledWrapper {...wrapperStyles}>
            <a href={`/Catalog/${categoryLink}`}>
                <StyledWrapper {...imageWrapperStyles}>
                    {image}
                </StyledWrapper>

                <Typography>{parse(title, parserOptions)}</Typography>


                <Typography>{parse(subTitle, parserOptions)}</Typography>
            </a>
      
        </StyledWrapper>
    )
}


const widgetModule: WidgetModule = {
    component: CustomBox,
    definition: {
        fieldDefinitions: [
            {
                name: fields.categoryLink,
                fieldType: "General",
                editorTemplate: "TextField",
                displayName: "Category Link (e.g categoryname)",
                defaultValue: "",
                //isRequired: true,
            },
            {
                name: fields.categoryIcon,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                tooltip: "Image Size has to be 330 x 229",
                defaultValue: "",
            },
            {
                name: fields.categoryIconSize,
                fieldType: "General",
                editorTemplate: "TextField",
                displayName: "Category Icon size",
                defaultValue: "",
            },
            {
                name: fields.title,
                fieldType: "Translatable",
                editorTemplate: "RichTextField",
                displayName: "Category Title",
                defaultValue: "",
                extendedConfig: { height: 100 },

            },
            {
                name: fields.subTitle,
                fieldType: "Translatable",
                editorTemplate: "RichTextField",
                displayName: "Sub Title",
                defaultValue: "",
                extendedConfig: { height: 100 },
            },
            {
                name: fields.altText,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
          
            ],
            group: "Common",
    }
}

export default widgetModule;